<template>
  <v-autocomplete
    v-model="model_value_computed"
    v-bind="$attrs"
    item-value="condicao"
    item-text="descricao"
    :items="items"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        indeterminate
        :color="cor_loading"
      ></v-progress-linear>
    </template>
  </v-autocomplete>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import api from "@/api/api";

const props = defineProps({
  model_value: {
    type: [Object, String],
    default: () => ({})
  },
  cor_loading: {
    type: String,
    default: 'red'
  },
  pedido: Object,
});

const emit = defineEmits(['update:model_value']);

const loading = ref(false);
const items = ref([]);

onMounted(buscarItens);

function buscarItens () {
  loading.value = true;

  api.get(`pedidos-compra/${this.pedido.idpedido}/exportacao/padre-cicero/condicoes-pagamento`)
    .then(resposta => {
      items.value = resposta.data.condicoes;
      loading.value = false;
    })
}

const model_value_computed = computed({
  get: () => props.model_value,
  set: valor => emit('update:model_value', valor)
});
</script>
